// Liste des spécialités proposées dans les formulaires (salariés et chantiers).
// Modifiable librement : ajouter/retirer une entrée ici suffit, le moteur
// d'assignation compare les libellés en ignorant accents et majuscules.
export const SKILLS = [
  'Peinture',
  'Plâtrerie',
  'Enduits',
  'Sols',
  'Façades',
  'Décoration',
  'Papier peint',
];
